import React, { useEffect, useState, useRef } from 'react';

import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import useSound from 'use-sound';

import Spinner from '../components/Spinner/Spinner';

import { useAuth } from '../hooks/auth';
import { useVisualViewportMetrics } from '../hooks/dynamicViewPort';
import api from '../services/apiClient';

import Message from '../interfaces/IMessage';
import MessageContainer from '../components/MessageContainer/MessageContainer';
import { ImageClipboardProvider } from '../hooks/imageClipboard';

import notificationSound from '../assets/sound/notification-mensage.mp3';
import notificationSoundStartChat from '../assets/sound/notification-start-chat.wav';

const Chat = (): any => {
  const {
    dataConnection,
    position,
    setPosition,
    signIn,
    setIdRequestSupport,
    loadLogoEmpresaCliente,
    configAparrence,
  } = useAuth();
  const { token, hubConnection } = dataConnection;
  const { idRequestSupport, urlLogoEmpresaCliente } = useAuth();

  const [messages, setMessages] = React.useState<Message[]>([]);
  const [showModal, setShowModal] = useState(true);
  const [showModalCloseChat, setShowModalCloseChat] = useState(false);
  const [showModalClosedChadSupport, setShowModalClosedChadSupport] =
    useState(false);
  const bntNotification = useRef<HTMLButtonElement>(null);
  const bntNotificationStartChat = useRef<HTMLButtonElement>(null);

  const { height: viewportHeight, offsetTop: viewportOffsetTop } =
    useVisualViewportMetrics();

  const [playSoundNotification] = useSound(notificationSound, {
    volume: 1,
  });
  const [playSoundNotificationStartChat] = useSound(
    notificationSoundStartChat,
    { volume: 1 }
  );

  const navigate = useNavigate();

  const getMessages = (message: Message[]): void => {
    if (message.length > 0) {
      setMessages(message);
      return;
    }

    const seqAtendimento = localStorage.getItem('@LiveChat:seqAtendimento');
    const tokenLocal = localStorage.getItem('@LiveChat:token');
    api
      .get(`api/AtendimentoMensagem/${seqAtendimento}`, {
        headers: { Authorization: `Bearer ${tokenLocal}` },
      })
      .then((response) => {
        const { success, data } = response.data;

        if (success) {
          setMessages(data);
        }
      });
  };

  useEffect(() => {
    const atendimentoEmAndamento = 2;
    const seqAtendimento = localStorage.getItem('@LiveChat:seqAtendimento');
    const IdConexaoCliente = localStorage.getItem('@LiveChat:connectionId');
    const nameClient = localStorage.getItem('@LiveChat:nameClient');
    const linkEmpresaCache = String(
      localStorage.getItem('@LiveChat:linkEmpresa')
    );

    loadLogoEmpresaCliente(linkEmpresaCache);

    const tryConnect = async (): Promise<void> => {
      await signIn({ nameClient: String(nameClient) });

      const newToken = localStorage.getItem('@LiveChat:token');

      api
        .patch(
          `/SolicitacaoAtendimento/update-idConnection`,
          {
            seqAtendimento: String(seqAtendimento),
            IdConexaoCliente,
          },
          { headers: { Authorization: `Bearer ${newToken}` } }
        )
        .then((response) => {
          const dataResponse = response.data;

          if (dataResponse.success) {
            setIdRequestSupport(String(seqAtendimento));
            setShowModal(
              dataResponse.data.seqStatusAtendimento !== atendimentoEmAndamento
            );
            const posicaoAtendimento = localStorage.getItem(
              '@LiveChat:posicaoAtendimento'
            );
            setPosition(Number(posicaoAtendimento));
            getMessages([]);
          }
        })
        .catch(() => {
          navigate('/');
        });
    };

    if (dataConnection.hubConnection === undefined) {
      if (seqAtendimento) {
        tryConnect();
      } else {
        navigate('/');
      }
    }
  }, []);

  const handleCloseChat = (): void => {
    api
      .patch(
        `/SolicitacaoAtendimento?idSupportRequest=${idRequestSupport}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((request) => {
        setShowModalCloseChat(false);
        const { success } = request.data;

        if (success) {
          dataConnection.hubConnection?.stop();
          navigate('/rating');
        }
      });
  };

  const handleClosedChatSupport = (): void => {
    setShowModalClosedChadSupport(false);
    dataConnection.hubConnection?.stop();
    navigate('/rating');
  };

  useEffect(() => {
    hubConnection?.on('UpdatePosition', (newPosition: number) => {
      setPosition(newPosition);
    });

    hubConnection?.on('StartChat', (startChat: boolean) => {
      if (startChat) {
        bntNotificationStartChat.current?.click();
        setShowModal(false);
      }
    });

    hubConnection?.on('ReceiveMessage', (message: Message[]) => {
      getMessages(message);
      bntNotification.current?.click();
    });

    hubConnection?.on('SupportFinished', () => {
      setShowModalClosedChadSupport(true);
    });
  }, [hubConnection]);

  const divStyleBackGround: React.CSSProperties = {
    background:
      configAparrence?.corPlanoFundoPrincipalChat === null
        ? `linear-gradient(rgba(255, 255, 255, ${
            Number(configAparrence?.opacidadeImagem) / 100
          }), rgba(255, 255, 255, ${
            Number(configAparrence?.opacidadeImagem) / 100
          })), url('${process.env.REACT_APP_API_URL}/BackGroundImage/${
            configAparrence?.planoFundoPrincipalChat
          }') no-repeat center/cover`
        : configAparrence?.corPlanoFundoPrincipalChat,
    position: 'fixed',
    top: viewportOffsetTop,
    left: 0,
    right: 0,
    overflow: 'hidden',
    height: `${viewportHeight}px`,
  };

  const blurOverlay: React.CSSProperties = {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    zIndex: -1,
  };

  return (
    <div>
      <Modal
        show={showModalCloseChat}
        onHide={() => setShowModalCloseChat(false)}
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column ">
            <p className="fw-bold">Encerrar atendimento</p>
            <p>Isso fechará a sessão atual. Gostaria de encerrar o chat?</p>
            <div className="d-flex justify-content-end">
              <Button
                variant="secondary"
                className="button-popup-secundary"
                onClick={() => setShowModalCloseChat(false)}
              >
                cancelar
              </Button>
              <Button
                className="button-popup-primary"
                onClick={handleCloseChat}
              >
                confirmar
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showModal} centered style={{ padding: '0.5rem' }}>
        <Modal.Body style={{ height: '12.81rem' }}>
          <div className="d-flex align-items-center div-spinner">
            <div className="me-3 spinner-style">
              <Spinner />
            </div>
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ width: '80%' }}
            >
              <p className="text-center">
                No momento, todos os atendentes estão ocupados, mas fique
                tranquilo(a), você será atendido(a) em breve.
              </p>
              <p className="fw-bold small">{`Sua posição na fila é ${position}.`}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalClosedChadSupport}
        onHide={() => handleClosedChatSupport()}
      >
        <Modal.Header closeButton>
          <Modal.Title>Atenção</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          O atendimento foi encerrado, você será redirecionado para a página de
          pesquisa de satisfação do atendimento.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleClosedChatSupport()}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="w-100" style={divStyleBackGround}>
        <div className="position-absolute" style={blurOverlay} />
        <Button
          className="d-none"
          ref={bntNotification}
          onClick={() => playSoundNotification()}
        />
        <Button
          className="d-none"
          ref={bntNotificationStartChat}
          onClick={() => playSoundNotificationStartChat()}
        />
        <div className="div-title">
          <img
            className="img-logo"
            src={urlLogoEmpresaCliente}
            alt="Logo Cliente"
          />
          <p className="title" style={{ color: 'var(--cor-titulo)' }}>
            Suporte Online
          </p>
          <Button
            onClick={() => setShowModalCloseChat(true)}
            className="button-close-chat"
          >
            <img src="./assets/x.svg" alt="X" />
          </Button>
        </div>
        <ImageClipboardProvider>
          <MessageContainer messages={messages} getMessages={getMessages} />
        </ImageClipboardProvider>
      </div>
    </div>
  );
};

export default Chat;
